import { __decorate } from "tslib";
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import FbLoginButton from '@/components/auth/FbLoginButton.vue';
import UserSettings from '@/views/shared/UserSettings.vue';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import UnreadNotificationsCount from '@/components/v2/UnreadNotificationsCount';
import InboxWithNotificationCount from '@/components/v3/inbox_manager/InboxMessagesCount.vue';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import { ScrollToElement } from '@/helpers/mixins/ScrollToElement';
import { EasingOption } from '@/helpers/entities/enums/EasingOption';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import WhiteLabelRedirectMixin from '@/helpers/mixins/WhiteLabelRedirectMixin';
import { Mutation, Getter } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
import ActionButton from '@/components/action_button/Index.vue';
import { DIY } from '@/helpers/constants/Store';
import BaseTopNavAppName from '@/components/v2/BaseTopNavAppName.vue';
import FormatNotificationCountMixin from '@/helpers/vue_mixins/FormatNotificationCountMixin';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
import { STORE_MANAGEMENT } from '@/helpers/constants/CustomBundleKeys';
import FacebookPixelMixin from '@/helpers/vue_mixins/v2/FacebookPixelMixin';
import NetworkDistributorMixin from '@/helpers/vue_mixins/v2/network_distributor/NetworkDistributorMixin';
import me from '@/plugins/graphql/queries/me.gql';
import { UserType } from '@/helpers/entities/enums/UserType';
import UserAgentMixin from '../../helpers/mixins/UserAgentMixin';
import AlertMixin from '../../helpers/vue_mixins/AlertMixin';
const opts = { namespace: NAV_DRAWER };
let TopNav = class TopNav extends Mixins(Mixins(RouteParamsAppMixin, ViewportSizeMixin, FormatNotificationCountMixin, RouterPathMixin, FacebookPixelMixin), UserAgentMixin, WhiteLabelRedirectMixin, NetworkDistributorMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.me = null;
        this.currentSectionId = 'main';
    }
    get userIsAuthenticated() {
        return this.$store.getters['session/authenticated'];
    }
    /* Temporary set to method for future development */
    chatgenieLogoUrl() {
        if (this.whiteLabel) {
            return this.whiteLabel.whiteLabelLogo;
        }
        // return require('@/assets/images/chatgenie-logo.png');
        // temporary until beta build
        if (this.xsOnly && !this.isAppsPath() && !this.isDiy() && this.appUUID) {
            return require('@/assets/images/Genie.svg');
        }
        return require('@/assets/images/chatgenie-logo-beta.svg');
    }
    chatgenieLandingLogoUrl() {
        if (this.whiteLabel) {
            return this.whiteLabel.whiteLabelLogo;
        }
        return require('@/assets/images/chatgenie-logo-landing-beta.png');
    }
    get links() {
        return [
            {
                title: 'Features',
                target: '/features',
            },
            {
                title: 'Merchants',
                target: '/merchants',
            },
            {
                title: 'Pricing',
                target: '/pricing',
            },
        ];
    }
    get linksMobile() {
        return [
            {
                title: 'Features',
                target: '/features',
                external: false,
            },
            {
                title: 'Merchants',
                target: '/merchants',
                external: false,
            },
            {
                title: 'Pricing',
                target: '/pricing',
                external: false,
            },
            {
                title: 'About Us',
                target: '/about-us',
                external: false,
            },
            {
                title: 'Press',
                target: '/press',
                external: false,
            },
            {
                title: 'Resources',
                target: 'https://www.youtube.com/channel/UCfI5QDh8PmAiU0outNApCkA',
                external: true,
            },
            {
                title: 'Get Started Free',
                target: '/login/client',
                external: false,
            },
        ];
    }
    get navigationHeight() {
        if (this.smAndUp) {
            return '72px';
        }
        return '62px';
    }
    get displayHomeNav() {
        return this.$store.state.displayHomeNav;
    }
    customSvgBtnIcon(fileName) {
        // eslint-disable-next-line import/no-dynamic-require
        return require(`@/assets/images/${fileName}.svg`);
    }
    active(elemId) {
        return elemId === this.currentSectionId;
    }
    hideDrawer() {
        this.toggleDrawer(false);
    }
    showDrawer() {
        this.toggleDrawer(true);
    }
    returnToHomePage() {
        this.redirectActions();
        this.hideDrawer();
    }
    goToSignInWithTracker(event) {
        this.goToSignIn();
        if (event === 'login') {
            this.fbPixelEventTracker('InitiateLogin');
        }
        else {
            this.fbPixelEventTracker('InitiateSignUp');
        }
    }
    goToAppsDashboard() {
        if (this.merchantUuid && this.isNetworkDistributor) {
            this.$router.push({
                name: 'reseller-mini-apps-overview',
                params: { resellerUuid: this.merchantUuid },
            });
            return this.hideDrawer();
        }
        this.$router.push('/apps');
        this.hideDrawer();
    }
    onLogoClick() {
        if (this.isAffiliate) {
            return;
        }
        if (this.userIsAuthenticated) {
            return this.goToAppsDashboard();
        }
        return this.returnToHomePage();
    }
    goTo(elemId) {
        this.currentSectionId = elemId;
        ScrollToElement(elemId, '', EasingOption.ease_in);
        if (elemId === 'apply') {
            this.fbPixelEventTracker('ClickCreateMyOwnMiniApp');
        }
    }
    goToUrl(link, isExternal) {
        if (isExternal) {
            window.open(link);
        }
        else {
            this.$router.push(link);
        }
    }
    goToPageSubscriptionPage() {
        this.$router.push({ name: 'page-subscription' });
    }
    goToPageMaintenancePage() {
        this.$router.push({ name: 'app-maintenance' });
    }
    previewInMessenger(app) {
        const fbPageId = app.activePage?.fbPageId || app.activeFbPageId;
        if (fbPageId) {
            this.goToUrl(`https://m.me/${fbPageId}`, true);
        }
        else {
            this.errorNotification('No active page');
        }
    }
    /**
     * Store Manager Dashboard Checker
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.21.0}
     */
    get isStoreManager() {
        return this.bundleKey === STORE_MANAGEMENT;
    }
    get isAffiliate() {
        const { params } = this.$route;
        return params.userType === UserType.Affiliate || this.$store.state.isAffiliateMerchant;
    }
    breakpointObserver() {
        if (this.mdAndDown) {
            this.hideDrawer();
        }
        else {
            this.showDrawer();
        }
    }
};
__decorate([
    Mutation('showNotifications', opts)
], TopNav.prototype, "showNotifications", void 0);
__decorate([
    Mutation('showPreLaunch', { namespace: DIY })
], TopNav.prototype, "showPreLaunch", void 0);
__decorate([
    Mutation('toggleDrawer', opts)
], TopNav.prototype, "toggleDrawer", void 0);
__decorate([
    Mutation('showInbox', { namespace: NAV_DRAWER })
], TopNav.prototype, "showInbox", void 0);
__decorate([
    Prop({ type: Object, default: null })
], TopNav.prototype, "whiteLabel", void 0);
__decorate([
    Prop({ type: Boolean, required: true })
], TopNav.prototype, "isLoading", void 0);
__decorate([
    Getter('resellerUuid')
], TopNav.prototype, "merchantUuid", void 0);
__decorate([
    Watch('$vuetify.breakpoint', { deep: true })
], TopNav.prototype, "breakpointObserver", null);
TopNav = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTopNavAppName,
            FbLoginButton,
            UserSettings,
            UnreadNotificationsCount,
            AppBasicDetails,
            InboxWithNotificationCount,
        },
        apollo: {
            me: {
                query: me,
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
    })
], TopNav);
export default TopNav;
